module.exports = __webpack_public_path__ + "img/logo-landing.9b7325ee.svg";